export default __webpack_public_path__ + "static/media/backdrop.e2a611a9.png";